import { render, staticRenderFns } from "./ResponseError.vue?vue&type=template&id=38f3178c&scoped=true"
import script from "./ResponseError.vue?vue&type=script&lang=js"
export * from "./ResponseError.vue?vue&type=script&lang=js"
import style0 from "./ResponseError.vue?vue&type=style&index=0&id=38f3178c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f3178c",
  null
  
)

export default component.exports